// extracted by mini-css-extract-plugin
export default {"modal":"TW-z","modalOverlay":"UW-z","outfitHeading":"VW-z"};